import React from 'react';

import { FormatHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { Company } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$types';
import { Alert, Box, RadioButton, Spacer, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { Card } from '@components';
import { rem } from '@helpers';

import { useAccountSelectorHelper } from './accountSelector.helper';

export const AccountSelector: React.FC = () => {
	const {
		resources,
		companyAccounts,
		onlyOneAccountResource,
		storeSelectedAccount,
		hasOnlyOneAccount,
		handleSelectAccount,
	} = useAccountSelectorHelper();

	return (
		<>
			{companyAccounts.length > 0 && (
				<>
					<Typography appearance="headline-200-02">{onlyOneAccountResource}</Typography>
					<Spacer vertical={40} />
					{companyAccounts.map(
						({ companyName, accounts, companyNif, companyCis }, index) =>
							accounts.length && (
								<div key={`${companyName}-${index}`}>
									<Typography appearance="subtitle-100-04">{companyName}</Typography>
									<Spacer vertical={16} />
									{accounts.map((account, accountIndex) => {
										const {
											name,
											number,
											accountableBalance,
											availableBalance,
											id,
											integratedSolution,
										} = account;
										return (
											<div key={`${number}-${accountIndex}`}>
												<Box styles={{ flexDirection: 'column', flexGrow: 1 }}>
													{!hasOnlyOneAccount ? (
														<Box
															styles={{ alignItems: 'center' }}
															onPress={() =>
																handleSelectAccount({
																	account: account,
																	companyName: companyName,
																	companyNif: companyNif,
																	companyCis: companyCis,
																})
															}
														>
															<RadioButton
																size={'small'}
																checked={storeSelectedAccount?.account.id === id}
															/>
															<Spacer horizontal={16} />

															<Card.AccountRow
																account={{
																	name: name,
																	number: FormatHelper.formatAccountNumber(
																		number,
																		Company.ab
																	),
																}}
																accountAvailableBalance={{
																	amount: availableBalance,
																	currency: 'EUR',
																}}
																accountAccountableBalance={{
																	amount: accountableBalance,
																	currency: 'EUR',
																}}
															/>
														</Box>
													) : (
														<Box styles={{ alignItems: 'center' }}>
															<Card.AccountRow
																account={{
																	name: name,
																	number: FormatHelper.formatAccountNumber(
																		number,
																		Company.ab
																	),
																}}
																accountAvailableBalance={{
																	amount: availableBalance,
																	currency: 'EUR',
																}}
																accountAccountableBalance={{
																	amount: accountableBalance,
																	currency: 'EUR',
																}}
															/>
														</Box>
													)}
													{/* hasGlobalSolutionIntegrated -> commented for now */}
													{storeSelectedAccount?.account.id === id && !integratedSolution && (
														<Box
															styles={{
																width: '100%',
																paddingLeft: rem(40),
																marginTop: rem(8),
															}}
														>
															<Alert
																severity="info"
																text={resources.accountWithoutIntegratedSolution}
															/>
														</Box>
													)}
												</Box>
												<Spacer vertical={accountIndex === accounts.length - 1 ? 40 : 16} />
											</div>
										);
									})}
								</div>
							)
					)}
				</>
			)}
		</>
	);
};
